<template>
  <div>
    <swiper
      class="swiper-autoplay fix"
      :options="swiperOptions"
      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
    >
      <swiper-slide
        v-for="data in swiperData"
        :key="data.img"
      >
        <b-img
          :src="data.img"
          fluid
          class="rounded-lg"
        />
      </swiper-slide>
      <div
        slot="pagination"
        class="swiper-pagination"
      />
    </swiper>
  </div>
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import { BImg } from 'bootstrap-vue'
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BImg,
  },
  data() {
    return {
      swiperOptions: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

      /* eslint-disable global-require */
      swiperData: [
        { img: 'https://anan-cargo.com/img/slide/slide1.jpg' },
        { img: 'https://anan-cargo.com/img/slide/slide2.jpg' },
        { img: 'https://anan-cargo.com/img/slide/slide3.webp' },
        { img: 'https://anan-cargo.com/img/slide/slide4.webp' },
      ],
      /* eslint-disable global-require */

    }
  },
}
</script>

<style scoped>
.fix{
  z-index: 0 !important;
}

</style>
